import cx from "classnames";
const Button = props => {
  const {
    variant,
    icon = false,
    className,
    disabled,
    children,
    size,
    ...rest
  } = props;
  return <button className={cx("text-sm font-medium", {
    "!bg-button-disabled-bg text-button-disabled-text !rounded-button-primary pointer-events-none": disabled && variant,
    //Secondary
    "border-button-secondary-border !rounded-button-secondary bg-button-secondary-bg hover:bg-button-secondary-hover text-button-secondary-text border px-4 transition-colors duration-300 ease-in-out md:px-8": variant === "secondary",
    //Primary
    "bg-button-primary-bg !rounded-button-primary text-button-primary-text hover:bg-button-primary-hover active:bg-button-primary-active border-button-primary-border border px-4 transition-colors duration-300 ease-in-out md:px-8": variant === "primary",
    //Ghost
    "border-button-ghost-border !rounded-button-ghost text-button-ghost-text hover:bg-button-ghost-hover active:bg-button-ghost-active border px-4 transition-colors duration-300 ease-in-out md:px-8": variant === "ghost",
    //Icon
    "pe-10 md:pe-14": icon,
    //Medium Size
    "h-9 md:h-11": size === "md",
    //Small Size
    "py-2": size === "sm"
  }, className)} disabled={disabled} {...rest} data-sentry-component="Button" data-sentry-source-file="Button.jsx">
      {children}
    </button>;
};
Button.displayName = "Button";
export default Button;